import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'

export default class extends Component {
  render() {
    return (
      <HeaderView title="使用帮助">
        <div>
          <p className={styles.title}>常见问题:</p>
          <p className={styles.step}>
            <span className={styles.stepTitle}>Q：什么是员工系统？</span>
            <br />
            <span>
              A：员工系统是婚礼纪提供给商家的一款店铺精细化管理工具，商家可以设置多个员工账号，员工账号仅拥有订单管理、预约管理、评价管理、动态管理、私信、通知等客资处理功能。
            </span>
          </p>
          <p className={styles.step}>
            <span className={styles.stepTitle}>
              Q：所有商家都可以开通员工系统吗？
            </span>
            <br />
            <span>A：是的，目前所有版本的商家都可以免费使用员工系统。</span>
          </p>
          <p className={styles.step}>
            <span className={styles.stepTitle}>Q：如何使用员工系统？</span>
            <br />
            <span>
              A：请登录婚礼纪商家中心（网页版）-客服账号管理-客服账号管理，点击新增员工账号，输入相关信息，点击确认创建即可。
            </span>
          </p>
          <p className={styles.step}>
            <span className={styles.stepTitle}>Q：如何管理多个员工？</span>
            <br />
            <span>
              A：当使用了多个员工时，可在员工管理-在线状态中管理各账号员工的在线状态，在线状态为在线的员工账号将会收到新用户的私信（老客户私信将继续分配给所属员工，点击结束会话后，客户再发起私信将会被重新分配）。
            </span>
          </p>

          <p className={styles.step}>
            <span className={styles.stepTitle}>Q：私信是怎么分配的？</span>
            <br />
            <span>
              A：当有新的私信时，优先分配给当前状态更空闲的员工，其次为当天工作量更低的员工，都相同则随机进行分配。当员工在十分钟内未回复私信，则分配给其他在线员工。
            </span>
          </p>
          {/*<p className={styles.step}>*/}
          {/*<span className={styles.stepTitle}>*/}
          {/*Q：我可以查看各个员工的接待情况吗？*/}
          {/*</span>*/}
          {/*<br />*/}
          {/*<span>*/}
          {/*A：可以的，您可以在员工管理-员工数据中按天查看各员工账号的接待详情，包括私信数、十分钟内未回复私信数、十分钟回复率、一小时回复率等。*/}
          {/*</span>*/}
          {/*</p>*/}
        </div>
        <div>
          <p className={styles.title}>常规情况：</p>
          <p className={styles.step}>
            <span className={styles.stepTitle}>第一步：负载分配</span>
            <br />
            <span>
              当有新私信进来时，优先分配给待回复私信数量最少的在线员工。
            </span>
          </p>
          <p className={styles.step}>
            <span className={styles.stepTitle}>第二步：按照工作量分配</span>
            <br />
            <span>如果员工待回复量一致，谁的当天工作量低，会话分配给谁。</span>
          </p>
          <p className={styles.step}>
            <span className={styles.stepTitle}>第三步：随机分配</span>
            <br />
            <span>
              如果所有员工待回复私信数量一致，当天工作量也一致，随机分配给一个员工，保证客户有人接待。
            </span>
          </p>
        </div>
        <div>
          <p className={styles.title}>异常情况：</p>
          <p className={styles.step}>
            1.
            1个登陆账号一条私信10分钟内未回复，则自动分配给其他在线账号，分配规则为
            优先分配给当天平均回复时间最短的员工。若没有其他账号在线，则依旧将私信保留在该账号；
          </p>
          <p className={styles.step}>
            2.
            若分配给下一个账号后，该账号10分钟内仍未回复，则继续进行分配，直至某账号10分钟内给与回复，若所有在线员工均未回复，则该私信在最后一个员工账号下不再继续分配；
          </p>
          <p className={styles.step}>
            3.天眼系统带来的私信与用户主动发起的私信，处理规则相同。
          </p>
        </div>
      </HeaderView>
    )
  }
}
